var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg9(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 48,
    viewBox: "0 0 80 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.0001,
    cy: 23.9997,
    rx: 8.55918,
    ry: 21.6232,
    fill: "#C9CEFF",
    stroke: "#18181B",
    strokeWidth: 1.5
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40,
    cy: 23.9999,
    rx: 8.55918,
    ry: 30.6011,
    transform: "rotate(60 40 23.9999)",
    fill: "#C9CEFF",
    stroke: "#18181B",
    strokeWidth: 1.5
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.55918,
    cy: 30.6011,
    rx: 8.55918,
    ry: 30.6011,
    transform: "matrix(-0.5 0.866025 0.866025 0.5 17.7783 1.28687)",
    fill: "#C9CEFF",
    stroke: "#18181B",
    strokeWidth: 1.5
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.0001,
    cy: 23.9997,
    rx: 8.55918,
    ry: 21.6232,
    stroke: "#18181B",
    strokeWidth: 1.5
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40,
    cy: 23.9999,
    rx: 8.55918,
    ry: 30.6011,
    transform: "rotate(60 40 23.9999)",
    stroke: "#18181B",
    strokeWidth: 1.5
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.55918,
    cy: 30.6011,
    rx: 8.55918,
    ry: 30.6011,
    transform: "matrix(-0.5 0.866025 0.866025 0.5 17.7783 1.28687)",
    stroke: "#18181B",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg9);
export default __webpack_public_path__ + "static/media/9.b3d6ddce490bf5a55a3e0c149fda32de.svg";
export { ForwardRef as ReactComponent };